/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { ButtonGroup, Card } from "react-bootstrap";
import { Button, Table } from "../../../components";
import { toast } from "react-toastify";
import { GetAllSellingStockList } from "../../../utilities/api/stock/sell";

const SellingStockList = () => {
  const navigate = useNavigate();
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const [data, setData] = useState([
    {
      srNo: 1,
      name: "",
      updatedAt: "",
      sellingPrice: 0,
      availableQuantity: 0,

      todaySoldQuantity: 0,
      todaySoldAmount: 0,
      totalProductValue: 0,
    },
  ]);

  const GetData = async () => {
    const result = await GetAllSellingStockList(SelectedFacility);
    if (result?.statusCode === 200) {
      setData(
        result.data.rows.map((item: any, index: number) => {
          return {
            id: item.id,
            srNo: index + 1,
            name: item.name,
            updatedAt: item.updatedAt,
            sellingPrice: item.sellingPrice,
            availableQuantity: item.availableQuantity,
            soldQuantity: item.soldQuantity,
            todaySoldQuantity: item.todaySoldQuantity,
            todaySoldAmount: Math.round(item.todaySoldTotalAmount),
            totalProductValue: Math.round(item.costPrice * item.totalQuantity),
            isActive: item.isActive === true ? "Active" : "Inactive",
          };
        })
      );
    } else {
      toast.error(result.response.data.message);
    }
  };



  useEffect(() => {
    GetData();
  }, [SelectedFacility]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "srNo",
      },
      {
        Header: "Product Name",
        accessor: "name",
      },
      {
        Header: "Last Inward Date",
        accessor: "updatedAt",
      },
      {
        Header: "Selling Price Per Unit",
        accessor: "sellingPrice",
      },
      {
        Header: "Current Available Quantity",
        accessor: "availableQuantity",
      },
      {
        Header: "Today Sold Quantity",
        accessor: "todaySoldQuantity",
      },
      {
        Header: "Today Sold Amount",
        accessor: "todaySoldAmount",
      },
      {
        Header: "Total Product Value",
        accessor: "totalProductValue",
      },
      {
        Header: "Status",
        accessor: "isActive",
      },
    ],
    []
  );
  const handleAdd = () => {
    navigate("/add-sell-stock");
  };

  const handleEdit = (id: string) => {
    navigate("/update-sell-stock", { state: id });
  };

  const handleUserInfo = (id: string) => {
    navigate("/sell-stock-info", { state: id });
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Sales Stock List</Card.Title>
            <ButtonGroup>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Inventory"
                name="add-inventory"
                id="add-inventory"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table
          columns={columns}
          data={data}
          handleEdit={handleEdit}
          HandleShow={handleUserInfo}
          hideDeleteAction={true}
        />
      </Card>
    </>
  );
};

export { SellingStockList };
